import {
  afterNextRender,
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  inject,
  Injector,
  input,
  Input,
  model,
  output,
  signal,
  viewChildren,
} from '@angular/core';

import { IconModule } from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';

import { Tab } from '@pp/core/entities';

import { TooltipComponent } from '../tooltip/tooltip.component';

@Component({
  selector: 'pp-tabs',
  imports: [TranslateModule, IconModule, TooltipComponent],
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsComponent implements AfterViewInit {
  #stickWidth = signal(0);
  readonly tabs = input<Tab[]>([]);
  readonly DEFAULT_ICON_SIZE = 20;
  readonly index = output<number>();
  readonly injector = inject(Injector);
  readonly components = viewChildren<ElementRef>('tab');

  x = 0;
  i = model<number>(0);

  @Input() set activeTabIndex(index: number) {
    if (typeof index !== 'number') {
      return;
    }

    this.i.set(index);
    afterNextRender(() => this.#initStickWidth(), { injector: this.injector });
  }

  get stickWidth(): number {
    return this.#stickWidth();
  }

  @HostListener('window:resize')
  onResize() {
    this.#initStickWidth();
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.#initStickWidth());
  }

  setActiveTab(event: any, tab: Tab): void {
    if (tab.disabled) {
      return;
    }
    this.#stickWidth.set(event.target.clientWidth);
    this.x = event.target.offsetLeft;
    this.index.emit(tab.index);
    this.i.set(tab.index);
  }

  #initStickWidth(): void {
    const components = this.components();
    if (!components) {
      return;
    }

    const tab = components[this.i()].nativeElement;

    this.#stickWidth.set(tab.clientWidth);
    this.x = tab.offsetLeft;
  }
}
